var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "showResultBox", attrs: { id: "mainBox" } }, [
    !_vm.tableData.length && !_vm.historyList.length
      ? _c("div", { staticClass: "emptyBox y-f y-f-a y-f-js" }, [
          _c("img", {
            staticClass: "robotImg y-f-shrink",
            attrs: { src: require("@/assets/images/gpt/3@2x.png") },
          }),
          _c("div", { staticClass: "emptyRight" }, [
            _c("div", { staticClass: "emptyTitle" }, [
              _c("img", {
                attrs: {
                  src: require("@/assets/images/gpt/icon_sel_reputation@2x.png"),
                },
              }),
              _c("span", [_vm._v(_vm._s(_vm.emptyTip.title))]),
            ]),
            _c("div", { staticClass: "emptyDesp" }, [
              _vm._v(_vm._s(_vm.emptyTip.desp)),
            ]),
          ]),
        ])
      : _c("div", [
          _vm.tableData.length
            ? _c("div", { staticClass: "resultParentBox" }, [
                _c("div", { staticClass: "tit-desp" }, [_vm._v("生成结果")]),
                _c("div", { staticClass: "resultMainBox" }, [
                  _c("div", { staticClass: "y-f y-f-a y-f-jb" }, [
                    _c(
                      "div",
                      { staticClass: "y-f y-f-a y-f-js" },
                      [
                        _vm.tableData[0].imageUrl || _vm.tableData[0].productPic
                          ? _c("el-image", {
                              staticClass: "picImg",
                              attrs: {
                                lazy: "",
                                src:
                                  _vm.tableData[0].imageUrl ||
                                  _vm.tableData[0].productPic,
                                "preview-src-list": [
                                  _vm.tableData[0].imageUrl ||
                                    _vm.tableData[0].productPic,
                                ],
                              },
                            })
                          : _vm._e(),
                        _c("div", { staticClass: "picDesp" }, [
                          _c("div", { staticClass: "picLabel" }, [
                            _vm._v("商品"),
                          ]),
                          _c("div", { staticClass: "picName" }, [
                            _vm._v(_vm._s(_vm.tableData[0].productName)),
                          ]),
                        ]),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "timmer" }, [
                      _vm._v(
                        _vm._s(_vm.tableData[0].createTime) +
                          " 由客户管家 官方提供"
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "line-hr" }),
                  _c(
                    "div",
                    { staticClass: "textBox" },
                    [
                      !_vm.tableData[0].isEdit
                        ? _c("div", { staticClass: "childDesBox" }, [
                            _c("span", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.resultTransferFn(
                                    _vm.tableData[0].productDesc ||
                                      _vm.tableData[0].sellingPoint ||
                                      _vm.tableData[0].replyRateContent
                                  )
                                ),
                              },
                            }),
                          ])
                        : [
                            _c("el-input", {
                              attrs: {
                                maxlength: _vm.formdata.lengthCode,
                                type: "textarea",
                                resize: "none",
                                autosize: { minRows: 2, maxRows: 12 },
                              },
                              model: {
                                value: _vm.tableData[0].productDesc,
                                callback: function ($$v) {
                                  _vm.$set(_vm.tableData[0], "productDesc", $$v)
                                },
                                expression: "tableData[0].productDesc",
                              },
                            }),
                            _c("div", { staticClass: "bottomBtn" }, [
                              _c("span", { staticClass: "wordLimit" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.tableData[0].productDesc
                                      ? _vm.tableData[0].productDesc.length
                                      : 0
                                  ) +
                                    "/" +
                                    _vm._s(_vm.formdata.lengthCode)
                                ),
                              ]),
                              _c(
                                "span",
                                {
                                  staticClass: "confirmBtn",
                                  on: {
                                    click: function ($event) {
                                      return _vm.confirmDialogFn(
                                        _vm.tableData[0],
                                        "current"
                                      )
                                    },
                                  },
                                },
                                [_vm._v("确定")]
                              ),
                            ]),
                          ],
                    ],
                    2
                  ),
                  _c("div", { staticClass: "bottomImage" }, [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/images/gpt/icon_edit@2x.png"),
                        title: "编辑",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.editProductDescFn("")
                        },
                      },
                    }),
                    _c("img", {
                      attrs: {
                        src: require("@/assets/images/gpt/icon_reset@2x.png"),
                        title: "重新生成",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.reCreateFn("")
                        },
                      },
                    }),
                    _c("img", {
                      attrs: {
                        src: require("@/assets/images/gpt/icon_copy@2x.png"),
                        title: "复制",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.copyTxtFn(
                            _vm.tableData[0].productDesc ||
                              _vm.tableData[0].sellingPoint ||
                              _vm.tableData[0].replyRateContent,
                            "已复制到您的鼠标剪切板"
                          )
                        },
                      },
                    }),
                    _c("img", {
                      attrs: {
                        src: require("@/assets/images/gpt/icon_del@2x.png"),
                        title: "删除",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.delProductDesFn(
                            _vm.tableData[0],
                            "current"
                          )
                        },
                      },
                    }),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm.historyList.length
            ? _c(
                "div",
                {
                  staticClass: "resultParentBox",
                  class: { "y-mt-30": _vm.tableData.length },
                },
                [
                  _c("div", { staticClass: "tit-desp" }, [_vm._v("历史记录")]),
                  _c(
                    "div",
                    { staticClass: "resultContentBox" },
                    [
                      _vm._l(_vm.historyList, function (item, idx) {
                        return [
                          _c(
                            "div",
                            { key: idx, staticClass: "resultMainBox y-mb-16" },
                            [
                              _c("div", { staticClass: "y-f y-f-a y-f-jb" }, [
                                _c(
                                  "div",
                                  { staticClass: "y-f y-f-a y-f-js" },
                                  [
                                    item.imageUrl || item.productPic
                                      ? _c("el-image", {
                                          staticClass: "picImg",
                                          attrs: {
                                            scrollContainer:
                                              ".resultContentBox",
                                            lazy: "",
                                            src:
                                              item.imageUrl || item.productPic,
                                            "preview-src-list": [
                                              item.imageUrl || item.productPic,
                                            ],
                                          },
                                        })
                                      : _vm._e(),
                                    _c("div", { staticClass: "picDesp" }, [
                                      _c("div", { staticClass: "picLabel" }, [
                                        _vm._v("商品"),
                                      ]),
                                      _c("div", { staticClass: "picName" }, [
                                        _vm._v(_vm._s(item.productName)),
                                      ]),
                                    ]),
                                  ],
                                  1
                                ),
                                _c("div", { staticClass: "timmer" }, [
                                  _vm._v(
                                    _vm._s(item.createTime) +
                                      " 由客户管家 官方提供"
                                  ),
                                ]),
                              ]),
                              _c("div", { staticClass: "line-hr" }),
                              _vm._l(item.list, function (child, childIdx) {
                                return [
                                  _c("div", { key: childIdx }, [
                                    _c(
                                      "div",
                                      { staticClass: "textBox" },
                                      [
                                        !child.isEdit
                                          ? _c(
                                              "div",
                                              { staticClass: "childDesBox" },
                                              [
                                                _c("span", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.resultTransferFn(
                                                        child.productDesc ||
                                                          child.sellingPoint ||
                                                          child.replyRateContent
                                                      )
                                                    ),
                                                  },
                                                }),
                                              ]
                                            )
                                          : [
                                              _c("el-input", {
                                                attrs: {
                                                  maxlength:
                                                    _vm.formdata.lengthCode,
                                                  type: "textarea",
                                                  resize: "none",
                                                  autosize: {
                                                    minRows: 2,
                                                    maxRows: 12,
                                                  },
                                                },
                                                model: {
                                                  value: child.productDesc,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      child,
                                                      "productDesc",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "child.productDesc",
                                                },
                                              }),
                                              _c(
                                                "div",
                                                { staticClass: "bottomBtn" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "wordLimit",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          child.productDesc
                                                            ? child.productDesc
                                                                .length
                                                            : 0
                                                        ) +
                                                          "/" +
                                                          _vm._s(
                                                            _vm.formdata
                                                              .lengthCode
                                                          )
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "confirmBtn",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.confirmDialogFn(
                                                            child
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("确定")]
                                                  ),
                                                ]
                                              ),
                                            ],
                                      ],
                                      2
                                    ),
                                    _c("div", { staticClass: "bottomImage" }, [
                                      _c("img", {
                                        attrs: {
                                          src: require("@/assets/images/gpt/icon_edit@2x.png"),
                                          title: "编辑",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.editProductDescFn(
                                              child,
                                              idx,
                                              childIdx
                                            )
                                          },
                                        },
                                      }),
                                      _c("img", {
                                        attrs: {
                                          src: require("@/assets/images/gpt/icon_reset@2x.png"),
                                          title: "重新生成",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.reCreateFn(
                                              child,
                                              idx,
                                              childIdx
                                            )
                                          },
                                        },
                                      }),
                                      _c("img", {
                                        attrs: {
                                          src: require("@/assets/images/gpt/icon_copy@2x.png"),
                                          title: "复制",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.copyTxtFn(
                                              child.productDesc,
                                              "已复制到您的鼠标剪切板"
                                            )
                                          },
                                        },
                                      }),
                                      _c("img", {
                                        attrs: {
                                          src: require("@/assets/images/gpt/icon_del@2x.png"),
                                          title: "删除",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.delProductDesFn(
                                              child,
                                              idx,
                                              childIdx
                                            )
                                          },
                                        },
                                      }),
                                    ]),
                                    childIdx != item.list.length - 1
                                      ? _c("div", {
                                          staticClass: "line-hr line-child",
                                        })
                                      : _vm._e(),
                                  ]),
                                ]
                              }),
                            ],
                            2
                          ),
                        ]
                      }),
                      _vm.hasMore
                        ? _c("div", { staticClass: "more" }, [
                            _vm._v("显示更多"),
                          ])
                        : _c("div", { staticClass: "more" }, [
                            _vm._v("我也是有底线的"),
                          ]),
                    ],
                    2
                  ),
                ]
              )
            : _vm._e(),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }